define(['./baseFor', '../object/keys'], function(baseFor, keys) {

  /**
   * The base implementation of `_.forOwn` without support for callback
   * shorthands and `this` binding.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Object} Returns `object`.
   */
  function baseForOwn(object, iteratee) {
    return baseFor(object, iteratee, keys);
  }

  return baseForOwn;
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-amd/modern/internal/baseForOwn.js
// module id = 190
// module chunks = 0